<template>
  <div v-if="group">
    <div v-if="mode=='self' && group.membershipStatus == 'Suspended'" class="text-danger">
      <i>{{ $t("page.event.currentlySuspended") }}</i>
    </div>
    <div v-if="mode=='self' && group.membershipStatus != 'Suspended'">
      <span v-if="event.meta.allowChange && (event.meta.counts.memberGoing || event.meta.counts.memberWaiting)">
        <mdb-btn @click="rsvpYes" color="warning" icon="pencil" rounded size="sm">
          {{ capitalize($t("page.event.changeRsvp")) }}
        </mdb-btn>
      </span>
      <span v-if="event.meta.allowGoing">
        <mdb-btn @click="rsvpYes" color="success" icon="check-circle" rounded
                 size="sm">{{ event.meta.yesLabel }}
        </mdb-btn>
      </span>

      <span v-if="!event.meta.allowGoing && event.meta.chargeImmediately && !event.meta.paymentOnFile">
        <router-link :to="'/group/' + group.vanityPath + '/billing'">
          <mdb-btn disabled color="success" icon="check-circle" rounded
                   size="sm">{{ event.meta.yesLabel }}
          </mdb-btn>
        </router-link>
      </span>

      <span v-if="event.meta.allowNotGoing">
        <mdb-btn @click="rsvpNo" color="danger" icon="times-circle" rounded
                 size="sm">{{ event.meta.notGoingButtonLabel }}
        </mdb-btn>
      </span>

      <div v-if="event.meta.allowGoing && event.meta.closeDate && !event.meta.closeReservations">
        <i>
          {{ $t("page.event.eventWillClose", {date: event.meta.closeDate}) }}
        </i>
      </div>

      <div v-if="!event.meta.allowGoing && event.meta.chargeImmediately && !event.meta.paymentOnFile"
           class="mt-2 text-danger">
        <router-link :to="'/group/' + group.vanityPath + '/billing'"> Please add a credit card</router-link>
        to your account if you wish to reserve a spot for this event.
      </div>
      <div v-if="event.meta.allowGoing && event.meta.chargeImmediately && event.meta.paymentOnFile"
           class="mt-2 text-warning">
        Your payment method on file will be charged immediately when you make a reservation to this event.
      </div>
    </div>

    <!--
      *********************************** MODAL ********************************************
    -->

    <mdb-modal :show="showModal" avatar position="top" size="lg" v-if="showModal && eventDetails">
      <mdb-modal-header :close="false">
        <img :src="eventDetails.avatar" alt="avatar" class="rounded-circle img-responsive">
      </mdb-modal-header>
      <mdb-modal-title class="mb-1 text-center">
        <div v-if="!eventDetails.isMe">
          <h6>{{ eventDetails.userName }}'s RSVP for {{ eventDetails.title }}</h6>
        </div>
        <div v-if="eventDetails.isMe && reservation.rsvpStatus == 'No Response Yet'">
          <h4 class="text-danger">{{ $t("page.event.almostDone") }}</h4>
          <h6>{{ $t("page.event.rsvpReview") }}</h6>
        </div>
      </mdb-modal-title>
      <mdb-modal-body class="mb-1 text-left">
        <div v-if="!eventDetails.attendeeBreakdown && eventDetails.costPerPerson > 0">
          <h5>{{ displayOptions.currencySymbol }}{{ eventDetails.costPerPerson }} {{ $t("page.event.perPerson") }}</h5>
        </div>

        <h5>Total Going: {{ totalGoing }}
          <span v-if="!allowAdd">(Max Reached)</span>
        </h5>

        <div v-if="!eventDetails.attendeeBreakdown && eventDetails.guestLimit > 0">
          <div v-if="eventDetails.requireGuestNames">
            <div v-for="guest in guests">
              <span v-if="editEnabled">
                <mdb-input placeholder="Guest's Name" type="text" v-model="guest.name">
                  <span class="input-group-text md-addon" slot="append">
                    <mdb-btn @click="deleteRow(guest,0)"
                             color="danger"
                             icon="trash" rounded
                             size="sm"/>
                  </span>
                </mdb-input>
              </span>
              <span v-else>{{ guest.name }}</span>
            </div>
            <mdb-btn @click="addRow(0)" rounded size="sm"
                     v-if="allowAdd"> {{ $t("page.event.addGuest") }}
            </mdb-btn>
          </div>

          <div v-if="!eventDetails.requireGuestNames">
            <mdb-btn :disabled="!editEnabled || reservation.numGuests ==0" @click="subtractGuest(0)"
                     color="warning" icon="user-minus"
                     rounded size="sm"> {{ capitalize($tc("page.event.guest", 1)) }}
            </mdb-btn>
            <mdb-btn :disabled="!allowAdd" @click="addGuest(0)" icon="user-plus" rounded size="sm">
              {{ capitalize($tc("page.event.guest", 1)) }}
            </mdb-btn>
          </div>
        </div>

        <div v-if="eventDetails.attendeeBreakdown && eventDetails.isMe">
          <b><i>{{ $t("page.event.breakdownText") }}</i></b>
        </div>

        <div v-if="eventDetails.attendeeBreakdown ">
          <div class="border-info" v-for="i in 5">
            <div v-if="eventDetails.requireGuestNames">
              <mdb-card class="mb-2" v-if="eventDetails['attendeeLabel'+i]">
                <mdb-card-header color="primary-color text-white">
                  <h6>
                    {{ eventDetails['attendeeLabel' + i] }} List
                    <span v-if="eventDetails['costType'+i] > 0">
                      - {{ displayOptions.currencySymbol }}{{ eventDetails['costType' + i] }}
                      {{ $t("page.event.perPerson") }}
                    </span>
                  </h6>
                </mdb-card-header>
                <mdb-card-body>
                  <div v-for="guest in guests" v-if="guest.attendeeTypeNum==(i)">
                    <span v-if="editEnabled">
                      <mdb-input placeholder="Name" type="text" v-model="guest.name">
                        <span class="input-group-text md-addon" slot="append">
                          <mdb-btn @click="deleteRow(guest,i)"
                                   color="danger"
                                   icon="trash"
                                   rounded
                                   size="sm"/>
                        </span>
                      </mdb-input>
                    </span>
                    <span v-else>{{ guest.name }}</span>
                  </div>

                  <mdb-btn @click="addRow(i)"
                           color="success"
                           icon="user-plus"
                           rounded
                           size="sm"
                           v-if="allowAdd">
                    {{ $t("common.button.add") }} {{ eventDetails['attendeeLabel' + i] }}
                  </mdb-btn>
                </mdb-card-body>
              </mdb-card>
            </div>

            <div v-if="!eventDetails.requireGuestNames">
              <div v-if="eventDetails['attendeeLabel'+i] && editEnabled">
                <mdb-row>
                  <mdb-col col="6">
                    <b>{{ eventDetails['attendeeLabel' + i] }} {{ $t("page.event.count") }}: </b> {{
                      reservation['countType'
                      + i]
                    }}
                  </mdb-col>
                  <mdb-col col="6">
                    <mdb-btn @click="addGuest(i)" color="success" icon="user-plus" rounded
                             size="sm"
                             v-if="allowAdd && eventDetails['attendeeLabel'+i]">{{
                        eventDetails['attendeeLabel' + i]
                      }}
                    </mdb-btn>
                    <mdb-btn color="danger" icon="user-minus" rounded size="sm"
                             v-if="reservation['countType'+i] > 0 && eventDetails['attendeeLabel'+i]"
                             v-on:click="subtractGuest(i)">
                      {{ eventDetails['attendeeLabel' + i] }}
                    </mdb-btn>
                  </mdb-col>
                </mdb-row>
              </div>
            </div>
          </div>
        </div>

        <h4 v-if="questions.length > 0"><u> {{ capitalize($tc("page.event.question", 1)) }}</u></h4>

        <div class="mb-4" v-for="question in questions">
          <span v-if="editEnabled">
            <div class="text-info">
              {{ question.required ? question.questionText + ' (Required)' : question.questionText }}
            </div>
            <mdb-input :id="'yn-y-'+question.id" v-model="question.yesNoAnswer"
                       :label="capitalize($t('common.label.yes'))" :name="'yn-y-'+question.id"
                       v-if="question.type=='Yes/No'"
                       radioValue="Yes" type="radio"/>
            <mdb-input :id="'yn-n-'+question.id" v-model="question.yesNoAnswer"
                       v-if="question.type=='Yes/No'"
                       :label="capitalize($t('common.label.no'))" :name="'yn-n-'+question.id"
                       radioValue="No" type="radio"/>
            <mdb-input
              :required="question.required"
              type="text"
              v-if="question.type=='Short Answer'"
              v-model="question.shortTextAnswer"/>
            <mdb-input
              :required="question.required"
              :rows="3"
              type="textarea"
              v-if="question.type=='Long Text'"
              v-model="question.longTextAnswer"/>
            <mdb-input v-if="question.type=='Acknowledgement'" :id="'checkbox-'+question.id"
                       v-model="question.acknowledged" :label="capitalize($t('common.label.acknowledged'))"
                       type="checkbox"/>

          </span>
          <span v-if="!editEnabled">
            <span v-if="question.yesNoAnswer">{{ question.yesNoAnswer }}</span>
            <span v-if="question.longTextAnswer">{{ question.longTextAnswer }}</span>
            <span v-if="question.shortTextAnswer">{{ question.shortTextAnswer }}</span>
          </span>
        </div>

        <div class="mt-4">
          <div class="text-danger" v-if="notReadyReason">{{ notReadyReason }}</div>
          <mdb-btn :disabled="!validToSubmit" @click="submit" icon="check">{{ $t("page.event.submitRsvp") }}</mdb-btn>
          <mdb-btn @click="cancel" color="danger" icon="times-circle">{{ $t("common.button.cancel") }}</mdb-btn>
        </div>
      </mdb-modal-body>
    </mdb-modal>

    <yes-no-modal @no="yesNoModal = false"
                  @yes="setNoConfirmed"
                  :question="$t('page.event.confirmRemoveRsvp')"
                  v-if="yesNoModal"/>

  </div>
</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import yesNoModal from "../common/YesNoModal";
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardGroup,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCarousel,
  mdbChip,
  mdbCol,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbLightbox,
  mdbListGroup,
  mdbListGroupItem,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalFooter,
  mdbModalHeader,
  mdbModalTitle,
  mdbRow,
  mdbSelect,
  mdbTooltip,
  mdbView,
} from 'mdbvue';
import BannerSmall from "../group/BannerSmall"
import UserContent from "../common/UserContent"

export default {
  name: 'RsvpControls',
  components: {
    UserContent,
    BannerSmall,
    mdbContainer,
    mdbChip,
    mdbCardGroup,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbLightbox,
    mdbCardFooter,
    mdbCardTitle,
    mdbCardText,
    mdbCardImage,
    mdbCarousel,
    mdbIcon,
    mdbInput,
    mdbView,
    mdbMask,
    mdbBtn,
    mdbRow,
    mdbListGroup,
    mdbListGroupItem,
    mdbCol,
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbSelect,
    mdbTooltip,
    mdbBadge,
    yesNoModal
  },
  props: {
    event: {
      type: Object,
      default: null
    },
    mode: {
      type: String,
      default: "self"
    },
    editEnabled: {
      type: Boolean,
      default: true
    },
    memberId: {
      type: Number,
      default: null
    }
  },
  computed: {
    group() {
      return this.$store.state.currentGroup
    },
    allowAdd: function () {

      if (!this.editEnabled) return false;

      if (!this.eventDetails.attendeeBreakdown && !this.eventDetails.requireGuestNames) {
        if (this.reservation.numGuests < this.eventDetails.guestLimit) return true;
        else return false
      }

      if (!this.eventDetails.attendeeBreakdown && this.eventDetails.requireGuestNames) {
        if (this.guests.length < this.eventDetails.guestLimit) return true;
        else return false
      }

      if (this.eventDetails.attendeeBreakdown && this.eventDetails.requireGuestNames) {
        if (this.guests.length < this.eventDetails.guestLimit + 1) return true;
        else return false
      } else {
        if ((this.reservation.countType1 + this.reservation.countType2 +
          this.reservation.countType3 + this.reservation.countType4 +
          this.reservation.countType5) < (this.eventDetails.guestLimit + 1)) return true;

        else return false;
      }
    },

    totalGoing: function () {
      if (!this.eventDetails.attendeeBreakdown && !this.eventDetails.requireGuestNames) {
        return this.reservation.numGuests + 1;
      }
      if (!this.eventDetails.attendeeBreakdown && this.eventDetails.requireGuestNames) {
        return this.guests.length + 1;
      }
      if (this.eventDetails.attendeeBreakdown) {
        return this.reservation.countType1 +
          this.reservation.countType2 +
          this.reservation.countType3 +
          this.reservation.countType4 +
          this.reservation.countType5;
      } else {
        return this.guests.length + 1;
      }
    },
    validToSubmit: function () {
      if (!this.editEnabled) return false;
      if (!this.eventDetails.attendeeBreakdown && !this.eventDetails.requireGuestNames) {
        return true;
      }
      if (this.eventDetails.attendeeBreakdown) {
        if (this.totalGoing == 0) {
          this.notReadyReason = "Nobody is going. Add at least one person (yourself) in order to submit.";
          return false;
        }
        if (this.guests.length > this.eventDetails.guestLimit + 1 && this.mode != "admin") {
          this.notReadyReason = "Guest limit exceeded. Reduce guest count before you may submit.";
          return false;
        }
      } else {
        if (this.guests.length > this.eventDetails.guestLimit && this.mode != "admin") {
          this.notReadyReason = "Guest limit exceeded. Reduce guest count before you may submit.";
          return false;
        }
      }
      if (this.eventDetails.requireGuestNames && this.mode != "admin") {
        for (var i = 0; i < this.guests.length; i++) {
          if (!this.guests[i].name) {
            this.notReadyReason = "A name is required for each participant before you may submit.";
            return false;
          }
        }
      }
      if (this.questions && this.mode != "admin") {
        for (var i = 0; i < this.questions.length; i++) {
          if (this.questions[i].required &&
            !this.questions[i].shortTextAnswer &&
            !this.questions[i].longTextAnswer &&
            !this.questions[i].acknowledged &&
            !this.questions[i].yesNoAnswer) {
            this.notReadyReason = "Required answers must be completed before submitting.";
            return false;
          }
        }
      }
      this.notReadyReason = "";
      return true;
    }
  },
  data() {
    return {
      displayOptions: null,
      eventDetails: null,
      guests: null,
      questions: null,
      reservation: null,
      showModal: false,
      notReadyReason: "",
      noConfirmed: false,
      yesNoModal: false
    }
  },
  mounted() {
    if (this.mode == "admin") {
      this.rsvpYes()
    }
  },
  methods: {
    setNoConfirmed: function () {
      this.noConfirmed = true
      this.yesNoModal = false
      this.rsvpNo()
    },
    rsvpNo: function () {
      if (this.event.meta.warnNotGoing && !this.noConfirmed) {
        this.noConfirmed = false
        this.yesNoModal = true
        return
      }
      let url = "/reservation/rsvpNo/" + this.event.eventId;
      this.$store.dispatch("setExecuting", true);
      api.post(url, {}).then(
        (results) => {
          this.$store.dispatch("updateGroupBalance")
          this.$emit("rsvpChanged")
        },
        (error) => {
          this.$notify.error({message: "Could not change RSVP. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    rsvpYes: function () {
      let url = "/reservation/rsvpData/" + this.event.eventId;
      if (this.memberId) url += "?member=" + this.memberId;
      this.$store.dispatch("setExecuting", true);
      api.get(url).then(
        (results) => {
          //this.rsvpData = results.data;
          this.displayOptions = results.data.displayOptions;
          this.eventDetails = results.data.eventDetails;
          this.guests = results.data.guests;
          this.questions = results.data.questions;
          this.reservation = results.data.reservation;
          this.showModal = true
          if (this.guests.length == 0 &&
            this.eventDetails.requireGuestNames &&
            this.eventDetails.attendeeBreakdown) {
            let row = {"attendeeTypeNum": 1, name: this.eventDetails.userName};
            this.guests.push(row);
            this.reservation.countType1 = 1;
          }
        },
        (error) => {
          this.$notify.error({
                               message: "Could not load RSVP controls. ",
                               timeOut: 20000
                             })
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    addRow: function (type) {
      let row = {"attendeeTypeNum": type, name: ""};
      if (type == 0) this.reservation.numGuests++;
      if (type == 1) this.reservation.countType1++;
      if (type == 2) this.reservation.countType2++;
      if (type == 3) this.reservation.countType3++;
      if (type == 4) this.reservation.countType4++;
      if (type == 5) this.reservation.countType5++;
      this.guests.push(row);
    },
    deleteRow: function (guest, type) {
      let index = this.guests.indexOf(guest);
      this.guests.splice(index, 1);
      if (type == 0) this.reservation.numGuests--;
      if (type == 1) this.reservation.countType1--;
      if (type == 2) this.reservation.countType2--;
      if (type == 3) this.reservation.countType3--;
      if (type == 4) this.reservation.countType4--;
      if (type == 5) this.reservation.countType5--;
    },
    submit: function () {
      let subData = {
        reservation: this.reservation,
        guests: this.guests,
        questions: this.questions
      };
      let url = "/reservation/rsvp/" + this.event.eventId;
      if (this.memberId) url += "?member=" + this.memberId;
      this.showModal = false;
      this.$store.dispatch("setExecuting", true);
      api.post(url, subData).then(
        (results) => {
          this.$store.dispatch("updateGroupBalance")
          this.$emit("rsvpChanged")
        },
        (error) => {
          if (error.response.status == 402) {
            let qs = encodeURI("?source=paywall-rsvp&group=" + this.event.title + "&return=" + "/event/show/" + this.event.eventId + "&message=" + error.response.data)
            this.$router.push("/user/billing" + qs)
          } else this.$notify.error({message: "Could not submit RSVP. " + error.response.data, timeOut: 20000});
          this.showModal = true
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    cancel: function () {
      this.showModal = false
      if (this.mode == "admin") this.$emit("rsvpCanceled")
    },
    addGuest: function (type) {
      if (type == 0) this.reservation.numGuests++;
      if (type == 1) this.reservation.countType1++;
      if (type == 2) this.reservation.countType2++;
      if (type == 3) this.reservation.countType3++;
      if (type == 4) this.reservation.countType4++;
      if (type == 5) this.reservation.countType5++;
    },
    subtractGuest: function (type) {
      if (type == 0) this.reservation.numGuests--;
      if (type == 1) this.reservation.countType1--;
      if (type == 2) this.reservation.countType2--;
      if (type == 3) this.reservation.countType3--;
      if (type == 4) this.reservation.countType4--;
      if (type == 5) this.reservation.countType5--;
    }
  }

};
</script>
